import React, { useState, useEffect } from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-router-dom';
import { REGISTRATION_ABI, REGISTRATION_ADDRESS, MATRIX_CONTRACT, MATRIX_ABI, USDT_ADDRESS, USDT_ABI } from '../constants/contract'
import { useUser } from "../context/UserContext";
import useWalletConnect from "../hooks/useWalletConnect";
import { Contract, isAddress, ethers } from "ethers";
import contractErrorHandler from "../hooks/contractErrorHandler";


const Slot = ({ level, amount, signer, account, totalUsers }) => {

    const { userData } = useUser();

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { parseError } = contractErrorHandler();

    const [isLoading, setIsLoading] = useState(false);



    const handleActivate = async () => {

        try {
            if (!signer) return alert("Connect your wallet first");

            setError('');
            setSuccess('');
            setIsLoading(true);

            const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);
            
             const usdt = new ethers.Contract(USDT_ADDRESS, USDT_ABI, signer);
             const amountToApprove = ethers.parseUnits(amount, 18);
             const userAddress = await signer.getAddress();
             const balance = await usdt.balanceOf(userAddress);
             
             if (balance < amountToApprove) {
               setError('Fund your BEP20 USDT  with atleast $'+amount)
               return;
             }

                        // Set gas price manually (e.g., 5 GWEI)
            const gasPrice = ethers.parseUnits("0.3", "gwei");

             const transaction = await usdt.approve(MATRIX_CONTRACT, amountToApprove);
             await transaction.wait();
             
             const tx = await contract.upgrade(parseInt(level), {
                gasPrice
              });
             await tx.wait();
             
 
            setSuccess('Successfully Activated');


        } catch (err) {
            setError(parseError(err))
        } finally {
            setIsLoading(false);
        }
    };


    

    const handleTest= async () => {

        try {
            if (!signer) return alert("Connect your wallet first");

            setError('');
            setSuccess('');
            setIsLoading(true);

            const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);
            
            /* 
            const tx6 = await contract.checkActivePkg('0x62F03f945262D13865195203d92999Da55C58a09', 5);

            console.log(tx6)
            
            const tx5 = await contract.upgradeDirect('0x62F03f945262D13865195203d92999Da55C58a09', 6);
            await tx5.wait();
            const tx7 = await contract.upgradeDirect('0x83036E9190F2c7F9e1C55a218BD1A1831ac9985A', 3);
            await tx7.wait();

            const tx8 = await contract.upgradeDirect('0x83036E9190F2c7F9e1C55a218BD1A1831ac9985A',4);
            await tx8.wait(); 
            const tx9 = await contract.upgradeDirect('0x83036E9190F2c7F9e1C55a218BD1A1831ac9985A',5);
            await tx9.wait(); 

            
            const tx10 = await contract.upgradeDirect('0x4421EdC080a6E4aa8751995195384FbE5E7355b8',5);
            await tx10.wait(); 
            
            const tx = await contract.upgradeDirect('0xFC67599f2b21C8D80c27d16594497f6848e73E51',1);
            await tx.wait();
          
            const tx2 = await contract.upgradeDirect('0xFC67599f2b21C8D80c27d16594497f6848e73E51',2);
            await tx2.wait();
            */
            setSuccess('Successfully Activated');


        } catch (err) {
            setError(parseError(err))
        } finally {
            setIsLoading(false);
        }
    };



    return (

        
        <div className="col-span-12 md:col-span-6 lg:col-span-6 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
            <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl">
                <div className="flex justify-between">
                  {/* <button onClick={()=>handleTest()}>Handle Test</button>  */}
                   <h3 className="text-md font-pmedium text-center text-secondary">
                        Level {level}:<br />
                        <span className="text-primary text-[10px]">Total Users: {totalUsers}</span>
                    </h3>

                    <h3 className="text-xl text-gray text-center font-psemibold">
                        ${amount}
                    </h3>
                </div>

                <div className='text-center flex justify-center'>
                    <img src={logo} className="w-[150px]" />
                </div>
                {userData?.user[0] >= parseInt(level) ? (
                    <div className='text-green-400 text-center'>This slot is active <i className='fa fa-check-circle'></i> </div>
/*                     <div className="flex justify-between my-5">
                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>

                        <div className="bg-secondary p-2 rounded-full shadow shadow-2xl"> </div>
                    </div> */) :

                    (<>
                        <div className='text-center'>
                            {!isLoading ? (<button onClick={() => handleActivate(level)} className='bg-secondary p-2 px-5 text-xs rounded-lg font-pmedium text-black'><i className="fa fa-unlock"></i> Activate Slot</button>)
                                :
                                (<button onClick={() => handleActivate(level)} className='bg-secondary p-2 px-5 text-xs rounded-lg font-pmedium text-black'><i className="fa fa-spin fa-spinner"></i></button>)
                            }
                        </div>
                    </>)

                }
                {success && (<div className="text-center overflow-hidden mt-3 text-xs text-green-400">{success}</div>)}

                {error && (<div className="text-center overflow-hidden mt-3 text-xs text-red-500">{error}</div>)}

            </div>
        </div>


    )
}

export default Slot;